export default {
    maintenanceDeleteMaintenanceServiceUnit_description: 'Are you sure you want to delete the Maintenance Service',
    maintenanceDeleteMaintenanceServiceUnit_success_message: 'Maintenance Service Removed Successfully',
}